import { connect } from 'react-redux';
import { IState } from '../../store/index';
import { ITenantsProps, Tenants } from './index';

function mapStateToProps(state: IState): ITenantsProps {
  return {
    offer: state.offerData.offer,
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const TenantsContainer = connect<ITenantsProps, any, any>(mapStateToProps)(Tenants);
